import { createFileRoute } from '@tanstack/react-router'

interface ISearchParams {
  token?: string
}

export const Route = createFileRoute('/uitnodiging-accepteren')({
  validateSearch: (search: Record<string, unknown>): ISearchParams => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
})
